var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('com-title',{attrs:{"text":"Library"}}),_c('com-item',{attrs:{"route":"Library.Games","text":"Games"}}),_c('com-item',{attrs:{"route":"Library.Collections","text":"Collections"}}),_c('com-item',{attrs:{"route":"Library.Settings","text":"Settings"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }